import { Worksheet, Task, Container, DayView } from "../types/types";
import type { DataDispatch } from "../data-context/DataContextProvider";
import { BASE_URL, parseApiError } from "../utils/apiCallsUtils";

export async function getKitchenSettings(params: {
  endpoint: string;
  buType: string;
  buCode: string;
  callBack: DataDispatch;
}): Promise<void> {
  const url = `${BASE_URL}/planning/${params.endpoint}?buType=${params.buType}&buCode=${params.buCode}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      const apiError = await parseApiError(response);
      console.error(`Error fetching ${params.endpoint}:`, apiError);
      params.callBack({ type: "SET_API_ERROR", payload: apiError });
      return;
    }

    const data = await response.json();

    if (params.endpoint === "worksheet") {
        params.callBack({
          payload: data.map((item: Worksheet) => ({
            id: item.id,
            name: item.name,
            selectedDayViewId: item.selectedDayViewId,
            prepDayBefore: item.prepDayBefore,
            buCode: item.buCode,
            buType: item.buType,
          })),
          type: "SET_WORKSHEETS",
        });
      } else if (params.endpoint === "task") {
        params.callBack({
          payload: data.map((item: Task) => ({
            taskId: item.taskId,
            taskNameLocal: item.taskNameLocal,
            buCode: item.buCode,
            buType: item.buType,
          })),
          type: "SET_TASKS",
        });
      } else if (params.endpoint === "container") {
        params.callBack({
          payload: data.map((item: Container) => ({
            containerId: item.containerId,
            containerNameLocal: item.containerNameLocal,
            buCode: item.buCode,
            buType: item.buType,
          })),
          type: "SET_CONTAINERS",
        });
      } else if (params.endpoint === "day-view-defaults") {
        params.callBack({
          payload: data.map((item: DayView) => ({
            dayViewId: item.dayViewId,
            timeslotName: item.timeslotName,
          })),
          type: "SET_DEFAULT_DAYVIEWS",
        });
      } else if (params.endpoint === "dayview") {
        params.callBack({
          payload: data.map((item: DayView) => ({
            dayViewId: item.dayViewId,
            timeslotNameLocal: item.timeslotNameLocal,
            dayViewIdParent: item?.dayViewIdParent,
            buType: item.buType,
            buCode: item.buCode,
            splitTimes: item.splitTimes,
          })),
          type: "SET_DAYVIEWS",
        });
      }
  } catch (error) {
    console.error(`Error fetching ${params.endpoint}:`, error);
  }
}

